import { motion } from 'framer-motion';
import { fadeUp, stagger } from './motionPresets';

const features = [
  { icon: '/icon-employee-tracking.svg', title: 'Employee & Visa Tracking', desc: 'Centralized profiles with H-1B, H-1B1, and E-3 visa details, LCA filing dates, and expiration tracking in one place.' },
  { icon: '/icon-paf-management.svg', title: 'PAF Document Management', desc: 'Upload, organize, and manage all required PAF documents with drag-and-drop simplicity.' },
  { icon: '/icon-compliance-automation.svg', title: 'Compliance Automation', desc: 'Auto-validate document requirements and track completion percentage for every PAF.' },
  { icon: '/icon-public-sharing.svg', title: 'Public Access File Sharing', desc: 'Generate secure, read-only shareable links for each PAF with sensitive data hidden.' },
  { icon: '/icon-audit-trail.svg', title: 'Audit Trail & Reporting', desc: 'Every action logged with timestamps. Export CSV reports for audits instantly.' },
  { icon: '/icon-alerts.svg', title: 'Alerts & Notifications', desc: 'Real-time alerts for expiring LCAs, missing documents, and compliance gaps.' },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 lg:py-28 bg-white" id="features">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div {...fadeUp} transition={{ duration: 0.5 }} className="text-center mb-16">
          <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wider mb-3">Features</p>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0F172A] tracking-tight mb-4">Everything you need for PAF compliance</h2>
          <p className="text-lg text-[#64748B] max-w-2xl mx-auto">Powerful tools designed specifically for H-1B, H-1B1, and E-3 Public Access File management.</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              {...stagger}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="group p-7 rounded-2xl border border-gray-100 bg-white hover:border-gray-200 transition-all hover:shadow-lg hover:shadow-gray-100/50"
            >
              <div className="mb-6">
                <img src={f.icon} alt={f.title} className="w-14 h-14" />
              </div>
              <h3 className="text-base font-bold text-[#0F172A] mb-2">{f.title}</h3>
              <p className="text-sm text-[#64748B] leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
